{
  "brand": {
    "name": "Sigma08",
    "tagline": "Plataforma de Aprendizagem com IA",
    "description": "Transforme a educação com experiências de aprendizagem personalizadas com IA"
  },
  "actions": {
    "submit": "Submeter",
    "cancel": "Cancelar",
    "save": "Guardar",
    "delete": "Eliminar",
    "edit": "Editar",
    "view": "Visualizar",
    "download": "Transferir",
    "upload": "Carregar",
    "search": "Pesquisar",
    "filter": "Filtrar",
    "sort": "Ordenar",
    "refresh": "Actualizar",
    "back": "Voltar",
    "next": "Seguinte",
    "previous": "Anterior",
    "close": "Fechar",
    "confirm": "Confirmar",
    "retry": "Tentar novamente",
    "loading": "A carregar...",
    "processing": "A processar..."
  },
  "status": {
    "success": "Sucesso",
    "error": "Erro",
    "warning": "Aviso",
    "info": "Informação",
    "pending": "Pendente",
    "active": "Activo",
    "inactive": "Inactivo",
    "completed": "Concluído",
    "failed": "Falhado",
    "cancelled": "Cancelado"
  },
  "time": {
    "today": "Hoje",
    "yesterday": "Ontem",
    "tomorrow": "Amanhã",
    "thisWeek": "Esta Semana",
    "lastWeek": "Semana Passada",
    "thisMonth": "Este Mês",
    "lastMonth": "Mês Passado",
    "thisYear": "Este Ano",
    "lastYear": "Ano Passado",
    "seconds": "segundos",
    "minutes": "minutos",
    "hours": "horas",
    "days": "dias",
    "weeks": "semanas",
    "months": "meses",
    "years": "anos"
  },
  "pagination": {
    "page": "Página",
    "of": "de",
    "items": "itens",
    "showing": "A mostrar",
    "to": "a",
    "perPage": "Por página",
    "goToPage": "Ir para a página"
  },
  "currency": {
    "symbol": "€",
    "code": "EUR"
  },
  "language": {
    "select": "Seleccionar Idioma",
    "current": "Português (Portugal)",
    "switch": "Mudar para Inglês"
  },
  "region": {
    "select": "Seleccionar Região",
    "current": "Portugal",
    "switch": "Mudar Região"
  }
}
